import React, { createContext, useContext } from 'react';

interface UnreadContextType {
  refetchUnreadCount: () => void;
}

const UnreadContext = createContext<UnreadContextType | undefined>(undefined);

export const UnreadProvider: React.FC<{
  children: React.ReactNode;
  refetchUnreadCount: () => void;
}> = ({ children, refetchUnreadCount }) => {
  return (
    <UnreadContext.Provider value={{ refetchUnreadCount }}>
      {children}
    </UnreadContext.Provider>
  );
};

export const useUnreadContext = () => {
  const context = useContext(UnreadContext);
  if (!context) {
    // Return a no-op function if context is not available
    return { refetchUnreadCount: () => {} };
  }
  return context;
};